import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { resolveLinkTarget } from './link-target.js';

marked.setOptions({
    breaks: true,
    gfm: true,
    headerIds: false,
    mangle: false,
});

const PURIFY_OPTIONS = {
    ALLOWED_TAGS: [
        'p', 'br', 'strong', 'em', 'b', 'i',
        'ul', 'ol', 'li',
        'h1', 'h2', 'h3', 'h4',
        'code', 'pre',
        'a', 'blockquote',
        'table', 'thead', 'tbody', 'tr', 'th', 'td',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
};

if (typeof DOMPurify.addHook === 'function') {
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        if (node.tagName === 'A') {
            const href = node.getAttribute('href');
            const pageOrigin = typeof window !== 'undefined' ? window.location.origin : '';
            const { target, rel } = resolveLinkTarget(href, pageOrigin);

            node.setAttribute('target', target);

            if (rel) {
                node.setAttribute('rel', rel);
            } else {
                node.removeAttribute('rel');
            }
        }
    });
}

/**
 * Asszisztens üzenet: minimális HTML (markdownből). User üzenet: plain escape.
 */
export function renderAssistantMessageHtml(content) {
    const text = (content ?? '').trim();

    if (text === '') {
        return '';
    }

    const rawHtml = marked.parse(text, { async: false });
    const sanitized = DOMPurify.sanitize(String(rawHtml), PURIFY_OPTIONS);

    // Scroll-wrap a táblák körül (Shadow DOM-ban is olvasható széles tartalom).
    return sanitized.replace(/<table\b[\s\S]*?<\/table>/gi, (tableHtml) => (
        `<div class="cb-md-table-wrap">${tableHtml}</div>`
    ));
}

export function escapeHtml(text) {
    return String(text ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
